import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {GroupService} from '../../apiModule1';

export const groupResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: GroupService = inject(GroupService)) => {
  return service.apiGroupGet({}, 'body', false, {transferCache: false});
};
